/* スクロールに合わせてふわっと下から上に表示
---------------------------------------------- */
export const FADE_UP = {
  init: function () {
    $(window).scroll(function () {
      fadeUp()
      fadeIn()
    })

    function fadeUp() {
      $('.fade-up-el').each(function () {
        const target = ($(this).offset().top -= 50)
        const scroll = $(window).scrollTop()
        const windowHeight = $(window).height()

        // 要素がウィンドウに入ったらフェードインする
        if (scroll > target - windowHeight) {
          $(this).addClass('is-fade-up')
        } else {
          // $(this).removeClass("is-fade-up");
        }
      })
    }

    function fadeIn() {
      $('.fade-in-el').each(function () {
        const target = ($(this).offset().top -= 50)
        const scroll = $(window).scrollTop()
        const windowHeight = $(window).height()
        const showHeight = Math.floor(windowHeight / 3)
        if (scroll > target - windowHeight + 100) {
          $(this).addClass('is-fade-in')
        }
      })
    }
  },
}
